import { Grid } from '@material-ui/core';
import React from 'react';
import VerticalCenter from 'src/vertical-center/vertical-center';
import { styles } from './customer-loyalty-search-results-styles';
import { useTranslation } from 'react-i18next';

const CustomerTableHeader: React.FC<ICustomerDisplayHeaderProps> = ({
  showPhoneNumberOnCustomerSearch,
  showStatusOnCustomerSearch,
}): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  return (
    <Grid container justifyContent='flex-start'>
      <Grid container item className={classes.firstNameItem}>
        <VerticalCenter justifyContent='flex-start'>
          <span>{t('CustomerDetailsForReturnView_FirstName')}</span>
        </VerticalCenter>
      </Grid>
      <Grid container item className={classes.lastNameItem}>
        <VerticalCenter justifyContent='flex-start'>
          <span>{t('CustomerDetailsForReturnView_LastName')}</span>
        </VerticalCenter>
      </Grid>
      {showStatusOnCustomerSearch && (
        <Grid
          container
          item
          className={classes.activeIcon}
          data-testid='customer-search-table-header-status'
        >
          <VerticalCenter justifyContent='center'>
            <span>{t('CustomerDetailsForReturnView_Status')}</span>
          </VerticalCenter>
        </Grid>
      )}
      {!showPhoneNumberOnCustomerSearch && (
        <Grid container item className={classes.mobileItem}>
          <VerticalCenter justifyContent='flex-start'>
            <span>{t('CustomerDetailsForReturnView_AltId')}</span>
          </VerticalCenter>
        </Grid>
      )}
      {showPhoneNumberOnCustomerSearch && (
        <Grid container item className={classes.mobileItem}>
          <VerticalCenter justifyContent={showStatusOnCustomerSearch ? 'flex-end' : 'flex-start'}>
            <span>{t('CustomerDetailsForReturnView_Phone')}</span>
          </VerticalCenter>
        </Grid>
      )}
      <Grid container item className={classes.homePhoneItem}>
        <VerticalCenter justifyContent={showStatusOnCustomerSearch ? 'flex-end' : 'flex-start'}>
          <span>{t('CustomerDetailsForReturnView_Home_Phone')}</span>
        </VerticalCenter>
      </Grid>
    </Grid>
  );
};

interface ICustomerDisplayHeaderProps {
  showPhoneNumberOnCustomerSearch: boolean;
  showStatusOnCustomerSearch: boolean;
}

export default CustomerTableHeader;
